"use client";

import type { MouseEvent } from "react";
import { useSelectedLayoutSegment } from "next/navigation";

import { AppLink } from "@/components/atoms/AppLink";
import { Paragraph } from "@/components/atoms/Paragraph";
import type { INavigationListProps } from "@/components/organisms/NavigationBar/types";
import cn from "@/helpers/cn";
import { useAppRouter } from "@/hooks/common/useAppRouter";

const NavigationList = ({
  list,
  selectedMenuItemValue,
}: INavigationListProps) => {
  const { appPush } = useAppRouter();
  const selectedSegment = useSelectedLayoutSegment();
  const selectedCheckFromSegmentOrProp =
    selectedMenuItemValue || selectedSegment;

  const handlePushByCategory = (event: MouseEvent<HTMLUListElement>) => {
    const { target } = event;
    if (!(target instanceof HTMLElement)) return;

    const liElement = target.closest("li");

    if (liElement && liElement instanceof HTMLElement) {
      const { value } = liElement.dataset;
      appPush(`/c/${value}`);
    }
  };

  return (
    <nav className="max-sm:h-[450px] max-sm:overflow-y-auto">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
      <ul
        className="flex flex-col gap-0.5 space-y-1"
        onClick={handlePushByCategory}
      >
        {list.map(({ label, value }) => (
          <li
            key={value}
            data-value={value}
            className={cn(
              `duration-300 cursor-pointer inline-flex justify-items-start items-center gap-2 hover:bg-primary-light hover:text-primary-selected rounded-md 
                focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring h-9 px-4 py-2 justify-start`,
              selectedCheckFromSegmentOrProp === value &&
                "bg-primary-light text-primary-selected",
            )}
          >
            <AppLink
              href={`/c/${value}`}
              aria-current={
                selectedCheckFromSegmentOrProp === value ? "page" : undefined
              }
              className="w-full"
            >
              <Paragraph size="small" fontWeight="medium">
                {label}
              </Paragraph>
            </AppLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default NavigationList;
